import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    IconButton,
    TextField,
    Typography,
    Tabs,
    Tab,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";

const isMobile = window.innerWidth < 900;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;

const TableContainer = styled.div`
  width: ${isMobile ? "100%" : "98%"};
  border-radius: 8px;
  margin-left: ${isMobile ? "0px" : "10px"};
  margin-bottom: ${isMobile ? "0px" : "10px"};
`;

const TabsContainer = styled.div`
  ${isMobile &&
    `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`;

const ButtonContainer = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center;
  margin-top: 10px;
`;

const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const AddNewIncentiveModal = ({
    props,
    onClose,
    id,
    fetchData,
}) => {
    const [tabValue, setTabValue] = useState(0);
    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const [minAmount, setMinAmount] = useState('');
    const [maxAmount, setMaxAmount] = useState('');
    const [incentivePercentage, setIncentivePercentage] = useState('');
    const [role, setRole] = useState('');
    const [series, setSeries] = useState('');
    const [roleData, setRoleData] = useState([])
    const [seriesData, setSeriesData] = useState([])
    const [loading, setLoading] = useState(false)
    const [incentiveType, setIncentiveType] = useState("");
    const [schoolCount, setSchoolCount] = useState(0);
    const [criteria, setCriteria] = useState("");
    const [studentCount, setStudentCount] = useState(0);
    // const handleRoleChange = (e) => {
    //     setRole(e.target.value);
    // };
    const handleRoleChange = (e) => {
    setRole(e.target.value);
    setSeries('');
    setSchoolCount(0);
    setCriteria('');
    setStudentCount(0);
};

    const handleSeriesChange = (e) => {
        setSeries(e.target.value);
    };

const resetForm = () => {
    setRole('');
    setSeries('');
    setMinAmount('');
    setMaxAmount('');
    setIncentivePercentage('');
    setSchoolCount(0);
    setCriteria('');
    setStudentCount(0);
};

    const submitIncentive = async () => {
        setLoading(true)
        try {
            // let data = {
            //     role: role,
            //     series:series,
            //     minAmount: minAmount,
            //     maxAmount: maxAmount,
            //     incentivePercent: incentivePercentage,
            // }
            let data = {
                role:role,
                series: role == "asm" ? "" : series,
                incentivePercent:incentivePercentage
            }
            let response = await window.Platform.database.addIncentiveNew(data);

            if (response.data) {
                window.NotificationUtils.showSuccess("Incentive added successfully!");
                setLoading(false);
                onClose();
                fetchData();
            }

        } catch (error) {
            setLoading(false)
            console.error('Error:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const updateIncentive = async () => {
        setLoading(true)
        try {
            // let data = {
            //     role: role,
            //     series:series,
            //     minAmount: minAmount,
            //     maxAmount: maxAmount,
            //     incentivePercent: incentivePercentage,
            //     id:props.id
            // }
            let data = {
                role:role,
                series: role == "asm" ? "" : series,
                incentivePercent:incentivePercentage,
                id:props.id
            }
            let response = await window.Platform.database.editIncentive(data);

            if (response.data) {
                window.NotificationUtils.showSuccess("Incentive Updated successfully!");
                setLoading(false);
                onClose();
                fetchData();
            }

        } catch (error) {
            setLoading(false)
            console.error('Error:', error);
            alert('An error occurred. Please try again later.');
        }
    };

      const submitIncentiveCondition = async () => {
        setLoading(true)
        try {
            let data = {
                seriesId: role == "asm" ? "" : series,
                role:role,
                minSchool:Number(schoolCount),
                minBooks:criteria,
                minStudents:studentCount,
                incentivePercent:Number(incentivePercentage)
            }
            let response = await window.Platform.database.addIncentiveNewCondition(data);

            if (response.status) {
                window.NotificationUtils.showSuccess(response?.message || "Incentive added successfully!");
                setLoading(false);
                onClose();
                fetchData();
            }
            else{
                setLoading(false);
                window.NotificationUtils.showError(response?.message || "Something went wrong");
            }

        } catch (error) {
            setLoading(false)
            console.error('Error:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const updateIncentiveCondition = async () => {
        setLoading(true)
        try {
            let data = {
                id:props.id,
                  seriesId: role == "asm" ? "" : series,
                role:role,
                minSchool:Number(schoolCount),
                minBooks:criteria,
                minStudents:studentCount,
                incentivePercent:Number(incentivePercentage)
            }
            let response = await window.Platform.database.editIncentiveCondition(data);

            if (response.status) {
                window.NotificationUtils.showSuccess(response?.message || "Incentive Updated successfully!");
                setLoading(false);
                onClose();
                fetchData();
            }
            else{
                setLoading(false);
                window.NotificationUtils.showError(response?.message || "Something went wrong");
            }
            

        } catch (error) {
            setLoading(false)
            console.error('Error:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const fetchRole = async () => {
        setLoading(true)
        let response = await window.Platform.database.fetchRoles();
        if (response.status == false && response.data) {
            setRoleData(response.data)
            setLoading(false)
        }
        else {
            setLoading(false)
        }
    }

    const fetchSeries = async () => {
        setLoading(true)
        let results = await window.Platform.database.getSeriesCategory();
        if (results.status == false && results.data) {
            setSeriesData(results.data)
            setLoading(false)
        }
        else {
            setLoading(false)
        }
      }
    useEffect(() => {
        if (props) {
            setMinAmount(props.minAmount || "");
            setMaxAmount(props.maxAmount || "");
            setIncentivePercentage(props.incentivePercent || "");
            setRole(props.role || props?.user_role || "");
            setSeries(props.seriesId || "");
            setIncentiveType(props?.incentiveType == "condition" ? "condition" : "percent" || "");
            setSchoolCount(props?.minSchool || 0);;
            setCriteria(props?.minBooks || "");
            setStudentCount(props?.minStudents || 0);
        }
        fetchRole()
        fetchSeries()
    }, [props])

    // console.log(series,"232322222323", props)
    // const isSubmitDisabled = !role || !series || !incentivePercentage || (!minAmount && !maxAmount);
    const isSubmitDisabled = role=="se" ? !role || !series || !incentivePercentage : !role || !incentivePercentage
    const isSubmitDisabled1 =  ( !role || !series || schoolCount<=0  || !criteria || studentCount <= 0 || !incentivePercentage );

    const renderContent = () => {
        return (
            <div className="incentive-management">
                <h2 className="incentive-managementtitle">Add Incentive</h2>
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Select Incentive Type</InputLabel>
                    <Select
                        // disabled={editMode}
                        label="Select Incentive Type"
                        value={incentiveType}
                        onChange={(e) => {
                            setIncentiveType(e.target.value);
                            // resetForm();
                            if (!props) {
                                resetForm();
                            }
                        }
                        }
                    >
                        <MenuItem key={1} value={"percent"} > Percent Based</MenuItem>
                        <MenuItem key={2} value={"condition"} > Condition Based</MenuItem>
                    </Select>
                </FormControl>
                {incentiveType == "percent" && <Stack direction="row" spacing={2} padding={0}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel style={{ background: 'white', padding: '0 4px' }}>Select Role</InputLabel>
                        <Select
                            style={{ fontSize: "1rem" }}
                            labelId="Select Role"
                            value={role}
                            onChange={handleRoleChange}
                            disabled={props ? true : false}
                        >
                            <MenuItem value="" hidden>
                                Select Role
                            </MenuItem>
                            <MenuItem value="se">
                                RM
                            </MenuItem>
                            <MenuItem value="asm">
                                ASM
                            </MenuItem>
                        </Select>
                    </FormControl>
                    {role == "se" && <FormControl variant="outlined" fullWidth>
                        <InputLabel style={{ background: 'white', padding: '0 4px' }}>Select Series</InputLabel>
                        <Select
                            style={{ fontSize: "1rem" }}
                            labelId="Select Series"
                            value={series}
                            onChange={handleSeriesChange}
                            disabled={props ? true : false}
                        >
                            {/* {seriesData.map((option, index) => (
                                <MenuItem key={index} value={option.seriesTableId}>
                                    {option.seriesName}
                                </MenuItem>
                            ))} */}
                            {seriesData.filter((t) => t.incentiveApplied).map((role, index) => (
                                <MenuItem key={index} value={role.seriesTableId}>{role.seriesName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
                    <FormControl style={{ width: "100%" }}>
                        <TextField
                            label="Enter Incentive %"
                            value={incentivePercentage}
                            type="number"
                            fullWidth
                            onChange={(e) => setIncentivePercentage(e.target.value)}
                        />
                    </FormControl>
                </Stack>}
                {incentiveType == "condition" && 
                <>
                <Stack direction="row" spacing={2} padding={0}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel style={{ background: 'white', padding: '0 4px' }}>Select Role</InputLabel>
                        <Select
                            style={{ fontSize: "1rem" }}
                            labelId="Select Role"
                            value={role}
                            onChange={handleRoleChange}
                            disabled={props ? true : false}
                        >
                            <MenuItem value="" hidden>
                                Select Role
                            </MenuItem>
                            <MenuItem value="se">
                                RM
                            </MenuItem>
                            {/* <MenuItem value="asm">
                                ASM
                            </MenuItem> */}
                        </Select>
                    </FormControl>
                    {role == "se" && <FormControl variant="outlined" fullWidth>
                        <InputLabel style={{ background: 'white', padding: '0 4px' }}>Select Series</InputLabel>
                        <Select
                            style={{ fontSize: "1rem" }}
                            labelId="Select Series"
                            value={series}
                            onChange={handleSeriesChange}
                            disabled={props ? true : false}
                        >
                            {/* {seriesData.map((option, index) => (
                                <MenuItem key={index} value={option.seriesTableId}>
                                    {option.seriesName}
                                </MenuItem>
                            ))} */}
                            {seriesData.filter((t) => t.incentiveApplied).map((role, index) => (
                                <MenuItem key={index} value={role.seriesTableId}>{role.seriesName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
                    {role == "se" && series && <FormControl style={{ width: "100%" }}>
                        <TextField
                            label="School Count"
                            value={schoolCount}
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            fullWidth
                            onChange={(e) => setSchoolCount(e.target.value)}
                        />
                    </FormControl>}
                    </Stack>
                   {role == "se" && series && schoolCount>0 && <Stack direction="row" mt={2} spacing={2} padding={0}>
                    {/* {role == "se" && series && schoolCount>0 && <FormControl style={{ width: "100%" }}>
                        <TextField
                            label="Criteria"
                            value={criteria}
                                onWheel={(e) => e.target.blur()}
                                type="text"
                                fullWidth
                                // onChange={(e) => setCriteria(e.target.value)}
                                onChange={(e) => {
                                    let value = e.target.value;

                                    value = value.replace(/^\s+/, "");

                                    value = value.replace(/\s{2,}/g, " ");

                                    setCriteria(value);
                                }}
                            />
                        </FormControl>} */}
                        {role == "se" && series && schoolCount > 0 && <FormControl variant="outlined" fullWidth>
                            <InputLabel style={{ background: 'white', padding: '0 4px' }}>Select Criteria</InputLabel>
                            <Select
                                style={{ fontSize: "1rem" }}
                                labelId="Select Series"
                                value={criteria}
                                onChange={(e) => setCriteria(e.target.value)}
                            >
                                <MenuItem key={0} value="">Select Criteria</MenuItem>
                                <MenuItem key={1} value="full kit / 7 title">Full Kit / 7 Titles</MenuItem>
                                <MenuItem key={2} value="1 or more Titles">1 or more Titles</MenuItem>
                                <MenuItem key={3} value="3 title minimum">3 title minimum</MenuItem>
                            </Select>
                        </FormControl>}
                        {role == "se" && series && schoolCount > 0 && criteria && <FormControl style={{ width: "100%" }}>
                            <TextField
                                label="Student Count"
                                value={studentCount}
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            fullWidth
                            onChange={(e) => setStudentCount(e.target.value)}
                        />
                    </FormControl>}
                    {role == "se" && series && schoolCount>0 && criteria && studentCount>0 && <FormControl style={{ width: "100%" }}>
                        <TextField
                            label="Enter Incentive %"
                            value={incentivePercentage}
                            type="number"
                            fullWidth
                            onChange={(e) => setIncentivePercentage(e.target.value)}
                        />
                    </FormControl>}
                </Stack>}
                </>}
                {/* <div className="incentive-managementform-group">
                    <label htmlFor="amount-range" className="incentive-managementform-label">Amount Range:</label>

                    <Stack direction={"row"} spacing={2} padding={0}>
                        <TextField
                            label="minimum Amount"
                            type="number"
                            fullWidth
                            value={minAmount}
                            onChange={(e) => setMinAmount(e.target.value)}
                        />
                        <span className="" style={{ marginTop: "14px", fontSize: "1rem" }}>to</span>
                        <TextField
                            label="maximum Amount"
                            type="number"
                            fullWidth
                            value={maxAmount}
                            onChange={(e) => setMaxAmount(e.target.value)}
                        />
                    </Stack>
                </div> */}
                
                {/* <label htmlFor="incentivePercentage" className="incentive-managementform-label">Incentive Percentage:</label>
                <Stack direction={"row"} spacing={2} padding={0}>
                    <FormControl style={{ width: "100%" }}>
                        <TextField
                            label="Enter Incentive %"
                            value={incentivePercentage}
                            type="number"
                            fullWidth
                            onChange={(e) => setIncentivePercentage(e.target.value)}
                        />
                    </FormControl>
                </Stack> */}
                {/* {incentiveType == "percent" &&  <div style={{ marginTop: "30px" }}>
                {!props ?  <Button
                        className="incentive-managementsubmit-button"
                        variant="contained"
                        color="primary"
                        onClick={submitIncentive}
                        disabled={isSubmitDisabled}
                    >
                        Submit
                    </Button> :
                    <Button
                        className="incentive-managementsubmit-button"
                        variant="contained"
                        color="primary"
                        onClick={updateIncentive}
                        disabled={isSubmitDisabled}
                    >
                        Update
                    </Button>}
                    
                </div>} */}
                {incentiveType == "percent" &&  <div style={{ marginTop: "30px" }}>
    <Button
        variant="contained"
        color="primary"
        onClick={props ? updateIncentive : submitIncentive}
        disabled={isSubmitDisabled}
    >
        {props ? "Update" : "Submit"}
    </Button>
</div>}
                 {/* {incentiveType == "condition" &&  <div style={{ marginTop: "30px" }}>
                {!props ?  <Button
                        className="incentive-managementsubmit-button"
                        variant="contained"
                        color="primary"
                        onClick={submitIncentive}
                        disabled={isSubmitDisabled}
                    >
                        Submit
                    </Button> :
                    <Button
                        className="incentive-managementsubmit-button"
                        variant="contained"
                        color="primary"
                        onClick={updateIncentive}
                        disabled={isSubmitDisabled}
                    >
                        Update
                    </Button>}
                    
                </div>} */}
                         {incentiveType == "condition" &&  <div style={{ marginTop: "30px" }}>
    <Button
        variant="contained"
        color="primary"
        onClick={props ? updateIncentiveCondition : submitIncentiveCondition}
        disabled={isSubmitDisabled1}
    >
        {props ? "Update Condition" : "Submit Condition"}
    </Button>
</div>}
            </div>
        );
    };

    return (
        <Dialog disableEnforceFocus maxWidth="md" fullWidth={true} open={true}>
            {loading && <OpaqueLoading />}
            <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
                <Typography variant={isMobile ? "h6" : "h5"}>
                    Add Incentive
                    <Tooltip title="Order Id">{id}</Tooltip>
                </Typography>
                <IconButton onClick={onClose}>
                    <CloseOutlined />
                </IconButton>
            </ModalHeaderContainer>
            <TableContainer>
                <TabsContainer>
                    <StyledTabs
                        variant="fullWidth"
                        value={tabValue}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="Incentive Details " />
                    </StyledTabs>
                    {tabValue == 0 && renderContent()}
                </TabsContainer>
            </TableContainer>
        </Dialog>
    );
};

export default AddNewIncentiveModal;
